/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum DashboardHandlingUnitType {
  Skid = "Skid",
  Pallet = "Pallet",
  Bin = "Bin",
  Box = "Box",
  Bundle = "Bundle",
  Cage = "Cage",
  Crate = "Crate",
  Drum = "Drum",
  Reel = "Reel",
  Roll = "Roll",
  Loose = "Loose",
  Other = "Other",
}

export function instanceOfDashboardHandlingUnitType(value: any): boolean {
  for (const key in DashboardHandlingUnitType) {
    if (Object.prototype.hasOwnProperty.call(DashboardHandlingUnitType, key)) {
      if (
        DashboardHandlingUnitType[
          key as keyof typeof DashboardHandlingUnitType
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function DashboardHandlingUnitTypeFromJSON(
  json: any,
): DashboardHandlingUnitType {
  return DashboardHandlingUnitTypeFromJSONTyped(json, false);
}

export function DashboardHandlingUnitTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DashboardHandlingUnitType {
  return json as DashboardHandlingUnitType;
}

export function DashboardHandlingUnitTypeToJSON(
  value?: DashboardHandlingUnitType | null,
): any {
  return value as any;
}

export function DashboardHandlingUnitTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): DashboardHandlingUnitType {
  return value as DashboardHandlingUnitType;
}
